import { observable, action, makeAutoObservable } from "mobx";
import { postLogin } from "../../serviceCalls";
import swal from "sweetalert2";

export default class VendorLoginStore {
  username = "";
  password = "";
  message;
  title;
  type;
  loading;

  constructor({ appStore, completeVendorLogin }) {
    makeAutoObservable(this, {
      username: observable,
      password: observable,
      message: observable,
      title: observable,
      submit: action,
      loading: observable,
      success: action,
    });
    this.completeVendorLogin = completeVendorLogin;
    this.appStore = appStore;
    this.nextLogin();
  }

  submit = () => {
    const { username, password, moduleId } = this;
    this.loading = true;
    postLogin({ username, password, moduleId })
      .then(this.success)
      .catch((err) => {
        swal.fire({
          icon: "error",
          title: "Login Failed.",
        });
        console.error(err);
      })
      .finally(() => (this.loading = false));
  };

  success = () => {
    this.requiredLogins.shift();
    if (!this.requiredLogins.length) {
      this.appStore.concludeVendorCreds();
      this.completeVendorLogin();
    }
    this.nextLogin();
  };

  nextLogin() {
    this.password = "";
    if (this.requiredLogins.length) {
      Object.assign(this, this.requiredLogins[0]);
    } else {
      this.title = "logins Complete";
      this.type = null;
      this.completeVendorLogin();
    }
  }

  get requiredLogins() {
    return this.appStore.authStore.requiredVendorLogins;
  }
}
